import { Heading, Stack, Text } from '@trmediaab/zebra';
import { useSafeLayoutEffect } from '@trmediaab/zebra-hooks';
import { CheckCircle } from '@trmediaab/zebra-icons';
import { brands } from '@trmediaab/zebra-utils';
import { useRef } from 'react';

import Layout from '../../components/Layout';
import NextButton from '../../components/NextButton';
import { useImmutableState } from '../../state';
import {
  getProductLink,
  getProductSite,
  isBetTipProduct,
} from '../../utils/orderUtils';
import useAutoNavigationToProduct from '../../utils/useAutoNavigationToProduct';

const DoneView = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { order, returnUrl, returnUrlText } = useImmutableState();

  if (order == null) {
    // Note: This should never happen, but we want to be sure
    throw new Error('Cannot render done view without order');
  }

  const link = getProductLink(order, returnUrl, returnUrlText);
  const site = getProductSite(order);
  const [navigationTimer, autoNavigationActive] = useAutoNavigationToProduct(
    link?.[0],
    isBetTipProduct(order) ?? false,
  );

  useSafeLayoutEffect(() => {
    wrapperRef.current?.scrollIntoView(false);
  }, []);

  return (
    <Layout
      areas={{ oneCol: ['main'] }}
      ref={wrapperRef}
      maxWidth="360px"
      mx="auto"
      mt="4"
      mb="5"
      pb="3,5"
    >
      <Layout.area area="main">
        <Layout>
          <Text textAlign="center">
            <CheckCircle size="56px" color="checkout.icon2" />
            <Heading.h4 mt="3" variant="checkout">
              Tack för din beställning!
            </Heading.h4>
          </Text>

          <Stack between={['2,5', null, 3]}>
            <Text textAlign="center">
              {order.isGiftPurchaseOrder
                ? 'En bekräftelse tillsammans med information gällande ditt presentkort har skickats till din e-postadress.'
                : 'En bekräftelse har skickats till din e-postadress.'}
            </Text>
            {autoNavigationActive && site != null && (
              <Text textAlign="center">
                Du skickas strax tillbaka till tipsmaterialet på{' '}
                {brands.getBrand(site).name}.
              </Text>
            )}
          </Stack>
          {autoNavigationActive && (
            <Text fontWeight="semiBold" textAlign="center">
              {Math.max(navigationTimer, 0)} sekunder
            </Text>
          )}
        </Layout>
      </Layout.area>

      {link != null && (
        <Layout.nextStepArea>
          <NextButton href={link[0]} label={link[1]} target="_parent" />
        </Layout.nextStepArea>
      )}
    </Layout>
  );
};

export default DoneView;
